import {
  NodeReferenceQuery,
  WorkflowChildReferenceBinding,
  WorkflowChildResetToTask,
  WorkflowDefinition,
  WorkflowEntity,
  WorkflowNode,
  WorkflowTagReference,
  WorkflowTaskQuery,
} from "../../../../../shared/schemas/workflows";
import { InputPath } from "../../../utils/workflow-node.utils";
import {
  BasicMeta,
  DescriptionComponentSection,
  QueriesComponentSection,
  ResetToNodeSection,
  TagsComponentSection,
} from "../shared/sections";

interface Props {
  id: string;
  workflow: WorkflowDefinition;
  taskRef: WorkflowChildResetToTask;
  queryOptions: WorkflowTaskQuery[];
  entityOptions: WorkflowEntity[];
  availablePaths: InputPath[];
  taskTriggersComponentSection: JSX.Element;
  tags: WorkflowTagReference[];
  onChangeTags: (tags: WorkflowTagReference[]) => void;
  onUpdateMeta: <T extends keyof BasicMeta>(name: T, value: BasicMeta[T]) => void;
  onUpdateTask: (id: string, task: WorkflowChildResetToTask) => void;
  onAddQuery: (nodeRefId: string) => void;
  onUpdateQuery: (nodeRefId: string, queryRefId: string, query: NodeReferenceQuery) => void;
  onRemoveQuery: (nodeRefId: string, queryRefId: string) => void;
  onAddNode: (id: string, node: WorkflowNode) => void;
  onRemoveNode: (id: string) => void;
}

function ResetToTaskSidebar(props: Props) {
  const handleChangeDescription = (description: string) => {
    props.onUpdateTask(props.id, {
      ...props.taskRef,
      meta: {
        ...props.taskRef.meta,
        description,
      },
    });
  };

  const handleSelectTargetNode = (node: WorkflowNode | null) => {
    props.onUpdateTask(props.id, {
      ...props.taskRef,
      to:
        node === null
          ? null
          : {
              bind: props.taskRef.to?.bind ?? {},
              node: node,
            },
    });
  };

  const handleUpdateBind = (name: string, bind: WorkflowChildReferenceBinding | null) => {
    if (props.taskRef.to?.node === undefined) {
      return;
    }

    props.onUpdateTask(props.id, {
      ...props.taskRef,
      to: {
        ...props.taskRef.to,
        bind:
          bind === null
            ? {}
            : {
                ...props.taskRef.to.bind,
                [name]: bind,
              },
      },
    });
  };

  return (
    <>
      <DescriptionComponentSection
        description={props.taskRef.meta.description}
        onChange={handleChangeDescription}
      />

      {props.taskTriggersComponentSection}

      <QueriesComponentSection
        availablePaths={props.availablePaths}
        entityOptions={props.entityOptions}
        id={props.id}
        queries={props.taskRef.queries}
        queryOptions={props.queryOptions}
        onAddQuery={props.onAddQuery}
        onRemoveQuery={props.onRemoveQuery}
        onUpdateQuery={props.onUpdateQuery}
      />

      <ResetToNodeSection
        availablePaths={props.availablePaths}
        entityOptions={props.entityOptions}
        sourceNode={props.taskRef}
        workflowChildren={props.workflow.children}
        onSelect={handleSelectTargetNode}
        onUpdateBind={handleUpdateBind}
      />

      <TagsComponentSection
        availablePaths={props.availablePaths}
        availableQueries={props.taskRef.queries}
        entityOptions={props.entityOptions}
        tags={props.tags}
        onChange={props.onChangeTags}
      />
    </>
  );
}

export default ResetToTaskSidebar;
